'use strict';

export default (function noKvKModal() {
    /**
     * @function onSubmit
     * @description
     * Submits the form via a fetch request.
     *
     * @param {SubmitEvent} event - SubmitEvent
     */
    function onSubmit(event) {
        const { target: form } = event;
        event.preventDefault();

        fetch(form.action, {
            method: 'POST',
            body: new FormData(form)
        })
            .then((res) => res.json())
            .then((res) => {
                if (!res.error) {
                    form.querySelector('.js-formfield').classList.add('d-none');
                    form.querySelector('[type="submit"]').classList.add('d-none');
                    form.querySelectorAll('.js-success').forEach((jsSuccess) => jsSuccess.classList.remove('d-none'));

                    const email = document.getElementById('dwfrm_shareConfiguration_email').value;
                    const successText = form.querySelector('.js-success-text');
                    const newSuccessTextElement = document.createElement('span');
                    newSuccessTextElement.innerHTML = successText.textContent.replace('{0}', `<strong>${email}</strong>`);
                    successText.textContent = '';
                    successText.appendChild(newSuccessTextElement);
                }
            });
    }

    /**
     * @function onHide
     * @description
     * Will reset the form to initial state
     *
     * @param {hide.bs.modal} event - On modal hide event
     */
    function onHide(event) {
        event.target.querySelector('[type="submit"]').classList.remove('d-none');
        event.target.querySelector('.js-formfield').classList.remove('d-none');
        event.target.querySelectorAll('.js-success').forEach((jsSuccess) => jsSuccess.classList.add('d-none'));
    }

    const modal = document.getElementById('kvk-modal');
    if (modal) {
        const form = modal.querySelector('form');

        modal.addEventListener('hidden.bs.modal', onHide);
        form.insertAdjacentHTML('beforeend', `<input type="hidden" name="${window.csrf.tokenName}" value="${window.csrf.token}" />`);
        form.addEventListener('submit', onSubmit);
    }
})();
